{
    "Accessibility Menu": "Meniu de accesibilitate",
    "Reset settings": "Resetează setările",
    "Close": "Închide",
    "Content Adjustments": "Ajustări conținut",
    "Adjust Font Size": "Ajustează dimensiunea fontului",
    "Highlight Title": "Evidențiază titlul",
    "Highlight Links": "Evidențiază legăturile",
    "Readable Font": "Font lizibil",
    "Color Adjustments": "Ajustări de culoare",
    "Dark Contrast": "Contrast întunecat",
    "Light Contrast": "Contrast luminos",
    "High Contrast": "Contrast ridicat",
    "High Saturation": "Saturație ridicată",
    "Low Saturation": "Saturație redusă",
    "Monochrome": "Monocrom",
    "Tools": "Instrumente",
    "Reading Guide": "Ghid de lectură",
    "Stop Animations": "Opriți animațiile",
    "Big Cursor": "Cursor mare",
    "Increase Font Size": "Mărește dimensiunea fontului",
    "Decrease Font Size": "Micșorează dimensiunea fontului",
    "Letter Spacing": "Spațierea literelor",
    "Line Height": "Înălțimea liniei",
    "Font Weight": "Grosimea fontului",
    "Dyslexia Font": "Font pentru dislexie",
    "Language": "Limbă",
    "Open Accessibility Menu": "Deschideți meniul de accesibilitate"
}